<template>
  <div>
    <b-row class="container-top-bar">
      <b-col>
        <b-navbar toggleable="lg" type="dark" variant="default">
          <b-navbar-brand href="#">
            <b-img v-if="ui_settings.primary_logo_url" class="top-bar-logo-left" :src="ui_settings.primary_logo_url" fluid alt="Responsive image"></b-img>
            <span v-else v-text="system_config.quickquote_title"></span>
            <b-img v-if="ui_settings.tertiary_logo_url" class="top-bar-logo-right" :src="ui_settings.tertiary_logo_url" fluid alt="Responsive image"></b-img>
          </b-navbar-brand>
          <!--
          <b-navbar-nav>
            <b-nav-item>{{$t('site.login')}}</b-nav-item>
          </b-navbar-nav>
          <b-collapse is-nav id="navCollapse">
            <b-navbar-nav toggleable class="ml-auto">
              <b-nav-item-dropdown right>
                <template slot="button-content">
                  <em>{{$t('site.lang')}}</em>
                </template>
                <b-dropdown-item href="#" @click="$i18n.locale='en'">English</b-dropdown-item>
                <b-dropdown-item href="#" @click="$i18n.locale='zh'">中文</b-dropdown-item>
              </b-nav-item-dropdown>
            </b-navbar-nav>
          </b-collapse>
          -->
        </b-navbar>
      </b-col>
    </b-row>
    <b-row class="container-header">
      <b-img v-if="ui_settings.background_logo_url" :src="ui_settings.background_logo_url" fluid alt="Responsive image"></b-img>
      <b-col v-else>
        <b-jumbotron :lead="system_config.firm_name.toUpperCase()"></b-jumbotron>
      </b-col>
    </b-row>
    <b-container class="mb-5">
      <div v-if="step === 0">
        <div v-if="survey !== null" id="surveyContainer"><survey :survey="survey" /></div>
      </div>
      <div v-if="step === 1" style="margin-top: 18px">
        <b-row class="container-input-user" style="background-color: #FFF">
          <b-col style="margin-top: 18px">
            <b-jumbotron style="background-color: #FFF" :lead="$t('site.priceTitle')">
              <b-form class="contact-form" :model="contactForm">
                <b-card class="taxpayer-card">
                  <template v-slot:header>
                      <p style="margin-bottom: 0px; text-align: left;">Taxpayer</p>
                  </template>
                  <b-input-group :prepend="$t('site.email')">
                    <b-input v-model="contactForm.email" :placeholder="$t('site.emailPC')" @blur="onEmailBlur" :state="emailState"></b-input>
                    <b-form-invalid-feedback class="email-warning-text" :force-show="emailState == false">
                      {{ emailWarningText }}
                    </b-form-invalid-feedback>
                  </b-input-group>
                  <b-button variant="secondary" class="sign-in-with" @click="signInWithGoogle" style="padding: 0px" :disabled="nextStepLoading"><img src="@/assets/web_dark_sq_SI@4x.png" alt="Sign in with Google" style="height: 34px; vertical-align: middle;" /><b-spinner v-if="nextStepLoading"></b-spinner></b-button>
                  <b-button variant="secondary" class="sign-in-with" @click="signInWithFacebook" :disabled="nextStepLoading">Sign in with Facebook<b-spinner v-if="nextStepLoading"></b-spinner></b-button>
                  <b-input-group :prepend="$t('site.firstName')">
                    <b-input v-model="contactForm.firstname" @blur="onFirstNameBlur" :state="firstNameState"></b-input>
                    <b-form-invalid-feedback class="firstname-warning-text" :force-show="firstNameState == false">
                      {{ firstNameWarningText }}
                    </b-form-invalid-feedback>
                  </b-input-group>
                  <b-input-group :prepend="$t('site.middleName')">
                    <b-input v-model="contactForm.middlename"></b-input>
                  </b-input-group>
                  <b-input-group :prepend="$t('site.lastName')">
                    <b-input v-model="contactForm.lastname" @blur="onLastNameBlur" :state="lastNameState"></b-input>
                    <b-form-invalid-feedback class="lastname-warning-text" :force-show="lastNameState == false">
                      {{ lastNameWarningText }}
                    </b-form-invalid-feedback>
                  </b-input-group>
                  <b-input-group :prepend="$t('site.phone1')">
                    <b-input v-model="contactForm.phone1"></b-input>
                  </b-input-group>
                  <b-input-group :prepend="$t('site.phone2')">
                    <b-input v-model="contactForm.phone2"></b-input>
                  </b-input-group>
                </b-card>
                <b-card class="spouse-card">
                  <template v-slot:header>
                      <p style="margin-bottom: 0px; text-align: left;">Spouse</p>
                  </template>
                  <b-input-group :prepend="$t('site.firstName')">
                    <b-input v-model="contactForm.spouse.firstname"></b-input>
                  </b-input-group>
                  <b-input-group :prepend="$t('site.middleName')">
                    <b-input v-model="contactForm.spouse.middlename"></b-input>
                  </b-input-group>
                  <b-input-group :prepend="$t('site.lastName')">
                    <b-input v-model="contactForm.spouse.lastname"></b-input>
                  </b-input-group>
                </b-card>
              </b-form>
              <div style="margin-top: 18px;">
                <b-row>
                  <b-col :cols="4">
                    <b-button variant="secondary" @click="prevStep" style="width: 100%">{{$t('site.backToEdit')}}</b-button>
                  </b-col>
                  <b-col :cols="8">
                    <b-button variant="secondary" @click="submitData" style="width: 100%" :disabled="nextStepLoading">{{$t('nextStep')}}<b-spinner v-if="nextStepLoading"></b-spinner></b-button>
                  </b-col>
                </b-row>
              </div>
            </b-jumbotron>
          </b-col>
        </b-row>
      </div>
      <div v-if="step == 2" style="margin-top: 18px">
        <b-row class="container-input-user" style="background-color: #FFF">
          <b-col style="margin-top: 18px">
            <b-alert :show="isEmailExists">Your email is already in our system. This engagement will be automatically linked.</b-alert>
            <p class="step2-p">Thank you for your information. Your information has been saved and forwarded to {{ urlContact.firstname + ' ' + urlContact.lastname }} and our team, and we will review shortly.</p>
            <p class="step2-p">If in the meantime you have any questions or concerns, you may reach us at {{ urlContact.phone1 ? urlContact.phone1 + ' or ' + urlContact.email : urlContact.email }}</p>
            <p class="step2-p">Thank you,</p>
            <p class="step2-p">{{ system_config.firm_name }}</p>
            <div style="margin-top: 18px;">
              <b-row>
                <b-col :cols="12" style="background-color: #FFF; padding: 24px;">
                  <b-button variant="secondary" @click="toHomePage"
                          style="width: 30%" :disabled="nextStepLoading">{{$t('site.toHomePage')}}<b-spinner v-if="nextStepLoading"></b-spinner></b-button>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </div>
      <div v-if="step == 3" style="margin-top: 18px">
        <b-row class="container-input-user" style="background-color: #FFF">
          <b-col style="margin-top: 18px; margin-bottom: 50px;">
            <div v-if="!system_config.docusign_enabled">
              <div style="text-align: left;" v-html="agreementHTMLFilter(system_config.taxreturn_agreement)"></div>
              <div style="text-align: left; margin-bottom: 24px;">
                <b-form-checkbox v-model="isAcceptAgreement">
                  I accept the terms
                </b-form-checkbox>
              </div>
              <div class="add-comments">
                <p v-html="comment" class="step3-p"></p>
              </div>
              <div style="margin-top: 18px;">
                    <b-row>
                      <b-col :cols="12" style="background-color: #FFF; padding: 24px;">
                        <b-button variant="secondary" @click="toStripePayPage" style="width: 100%" :disabled="!isAcceptAgreement">{{$t('nextStep')}}</b-button>
                      </b-col>
                    </b-row>
              </div>
            </div>
            <div v-else>
              <p>Thank you for your information.</p>
              <p>We are happy to assist with your return and based on our review of our data we can offer you a quote.  
                Included in our fees is electronic filing (when available) and optimization of filing position.  
                During this time you will have direct access to the team handling your return.</p>
              <p v-if="envelopeId && spouseFullName">Now please let your spouse {{ spouseFullName }} to sign</p>
              <div class="add-comments">
                <p v-html="comment" class="step3-p"></p>
              </div>
              <div style="margin-top: 18px;">
                    <b-row>
                      <b-col :cols="12" style="background-color: #FFF; padding: 24px;">
                        <b-button variant="secondary" @click="toDocusign(contactForm.email, fullName, spouseFullName, contactId, engagementId, envelopeId)" style="width: 30%" :disabled="nextStepLoading">
                          <p v-if="nextStepLoading" class="wait-text">Please, wait a moment while loading data</p><span>{{$t('site.toDocusign')}}</span>
                        </b-button>
                      </b-col>
                    </b-row>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
      <div v-if="step == 4" style="margin-top: 18px">
        <b-row class="container-input-user" style="background-color: #FFF">
          <b-col style="margin-top: 18px">
            <!-- 这里的price是总价的一半 -->
            <p>We estimate that we can prepare your return for the fee of <b>{{ price }}</b>.</p>
            <p>Please provide credit card information below to process an initial 100% deposit for us to get started.</p>
            <div style="margin-top: 18px;">
                  <b-row>
                    <b-col :cols="12" style="background-color: #FFF; padding: 20px;">
                      <stripe-pay @paymentCompleted="onPaymentCompleted"></stripe-pay>
                    </b-col>
                  </b-row>
            </div>
          </b-col>
        </b-row>
      </div>
      <div v-if="step == 5" style="margin-top: 18px">
        <b-row class="container-input-user" style="background-color: #FFF">
          <b-col style="margin-top: 18px">
            <p>Thank you for your deposit. Please continue to complete the detailed questionnaire:</p>
            <div style="margin-top: 18px;">
              <b-row>
                <b-col :cols="12" style="background-color: #FFF; padding: 24px;">
                  <b-button variant="secondary" @click="toPacioli2Questions()" style="width: 30%" :disabled="nextStepLoading">{{$t('site.toQuestionaires')}}<b-spinner v-if="nextStepLoading"></b-spinner></b-button>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </div>
      <div v-if="step == 6" style="margin-top: 18px">
        <b-row class="container-input-user" style="background-color: #FFF">
          <b-col style="margin-top: 18px">
            <p>The status of this engagement is already active, please login to engagement portal.</p>
            <div style="margin-top: 18px;">
              <b-row>
                <b-col :cols="12" style="background-color: #FFF; padding: 24px;">
                  <b-button variant="secondary" @click="toPacioli2()" style="width: 30%" :disabled="nextStepLoading">{{$t('site.login')}}<b-spinner v-if="nextStepLoading"></b-spinner></b-button>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </div>
      <div v-if="step == 7" style="margin-top: 18px">
        <b-row class="container-input-user" style="background-color: #FFF">
          <b-col style="margin-top: 18px">
            <p>There is a problem with your engagement status, please contact the administrator.</p>
            <div style="margin-top: 18px;">
              <b-row>
                <b-col :cols="12" style="background-color: #FFF; padding: 24px;"></b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </div>
      <div>
        <b-modal ref="modLogin" hide-footer :title="$t('site.login')">
           <b-row style="display: flex;flex-direction: row;align-items: center;margin-top: 12px">
             <b-col :cols="3">
               <span>{{$t('site.userName')}}</span>
             </b-col>
             <b-col :cols="9">
               <b-form-input v-model="user.name"></b-form-input>
             </b-col>
           </b-row>
          <b-row  style="display: flex;flex-direction: row;align-items: center;margin-top: 12px">
            <b-col :cols="3">
              <span>{{$t('site.password')}}</span>
            </b-col>
            <b-col :cols="9">
              <b-form-input type="password" v-model="user.password"></b-form-input>
            </b-col>
          </b-row>
        </b-modal>
      </div>
    </b-container>
      <div class="container-fluid footer fixed-bottom">
        <div v-if="ui_settings.secondary_logo_url"><b-img :src="ui_settings.secondary_logo_url" fluid alt="Responsive image"></b-img></div>
        <p v-else class="text-center copy-right-text">Copyright &copy {{ new Date().getFullYear() }}, Pacioli2.</p>
      </div>
  </div>
</template>

<style lang="scss">
  :root {
    --primary-color: #918300;
    --secondary-color: #000000;
    --tertiary-color: #888888;
    --alternative-color: #FFFFFF;
    --sv-h1-font-family: 'Cormorant Garamond', serif;
    --sv-main-font-family: 'Merriweather', serif;
  }

  .sv_header {
    .sv_header__text {
      color: #918300
    }
    font-family: var(--sv-main-font-family);
    h1, h2, h3 {
      font-family: var(--sv-h1-font-family);
    }
  }

  .sv_main {
    font-family: var(--sv-main-font-family);
    input[type="button"], input[type="button"]:hover,
    button, button:hover,
    .sv-boolean__switch, .sv_select_wrapper:before,
    .sv_progress_bar {
      background-color: var(--primary-color);
    }
    .sv_body, .sv_q_text_root:focus {
      border-color: var(--primary-color);
    }
  }

  body {
    background-color: #f6f6f6;
    font-family: var(--sv-main-font-family);
  }

    #app {
        .custom-control-input:checked ~ .custom-control-label::before {
            background-color: #364a69;
            border-color: #364a69;
        }

        .custom-control-input:focus ~ .custom-control-label::before {
            box-shadow: none;
        }

        .btn {
            width: auto !important;
        }

        .btn.sign-in-with {
            margin-bottom: 10px;
            width: calc(50% - 5px) !important;

            & + .sign-in-with {
                margin-left: 10px;
            }
        }

        .btn-primary {
            background-color: var(--primary-color);
            border-color: var(--primary-color);
        }

        .btn-secondary {
            background-color: var(--secondary-color);
            border-color: var(--secondary-color);
        }

        @keyframes inserted-data-v-5c6a0d00 {
            0% {
                background: #bdbdbd;
            }

            100% {
                background: #fff;
            }
        }

        .container-top-bar, .container-header {
            margin: 0;
        }

        .container-top-bar {
            // background-color: #383f4a;
            background-color: var(--alternative-color);
            position: fixed;
            width: 100%;
            z-index: 2;

            .col {
                @media screen and ('max-width: 440px') {
                    padding: 0;
                }

                @media screen and ('min-width: 1400px') {
                    max-width: 1340px;
                    padding: 0;
                    margin-left: auto;
                    margin-right: auto;
                }

                @media screen and ('min-width: 1600px') {
                    max-width: 1540px;
                    padding: 0;
                    margin-left: auto;
                    margin-right: auto;
                }

                @media screen and ('min-width: 1800px') {
                    max-width: 1740px;
                    padding: 0;
                    margin-left: auto;
                    margin-right: auto;
                }

                .navbar {
                    @media screen and ('max-width: 440px') {
                        padding: 0.5rem;
                    }

                    .navbar-brand {
                        display: block;
                        width: 100%;
                    }

                    .top-bar-logo-left {
                        float: left;
                        width: 60px;

                        @media screen and ('max-width: 575px') {
                            width: 60px;
                        }

                        @media screen and ('min-width: 992px') {
                            width: 80px;
                        }

                        @media screen and ('min-width: 1400px') {
                            width: 100px;
                        }

                        @media screen and ('min-width: 1600px') {
                            width: 120px;
                        }

                        @media screen and ('min-width: 1800px') {
                            width: 140px;
                        }
                    }

                    .top-bar-logo-right {
                        float: right;
                        width: 60px;

                        @media screen and ('max-width: 575px') {
                            width: 60px;
                        }

                        @media screen and ('min-width: 992px') {
                            width: 80px;
                        }

                        @media screen and ('min-width: 1400px') {
                            width: 100px;
                        }

                        @media screen and ('min-width: 1600px') {
                            width: 120px;
                        }

                        @media screen and ('min-width: 1800px') {
                            width: 140px;
                        }
                    }

                    .navbar-nav {
                        @media screen and ('max-width: 440px') {
                            display: flex;
                            flex-direction: row;
                            align-content: space-around;
                            width: 100%;
                        }

                        li {
                            @media screen and ('max-width: 440px') {
                                width: 100%;
                            }
                        }
                    }

                    .navbar-collapse {
                        @media screen and ('max-width: 991px') {
                            background-color: rgba(255,255,255,0.1);
                            border-radius: 8px 8px 0 0;
                            margin-top: 15px;
                        }

                        li {
                            @media screen and ('max-width: 440px') {
                                width: 100%;
                            }
                        }
                    }
                }
            }

            a {
                color: white;
            }

            span {
                color: #000000;
            }
        }

        .container-header {
            background-color: #000000;
            // background: rgba(54,74,105,1);
            // background: -moz-linear-gradient(top, rgba(54,74,105,1) 0%, rgba(14,25,41,1) 100%);
            // background: -webkit-gradient(left top, left bottom, color-stop(0%, rgba(54,74,105,1)), color-stop(100%, rgba(14,25,41,1)));
            // background: -webkit-linear-gradient(top, rgba(54,74,105,1) 0%, rgba(14,25,41,1) 100%);
            // background: -o-linear-gradient(top, rgba(54,74,105,1) 0%, rgba(14,25,41,1) 100%);
            // background: -ms-linear-gradient(top, rgba(54,74,105,1) 0%, rgba(14,25,41,1) 100%);
            // background: linear-gradient(to bottom, rgba(54,74,105,1) 0%, rgba(14,25,41,1) 100%);
            filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#364a69', endColorstr='#0e1929', GradientType=0 );
            border-radius: 0;
            box-shadow: 0 4px 25px 0 rgba(0,0,0,0.1);
            color: #918300;
            // margin-bottom: -90px;
            padding-top: 85px;
            position: relative;
            z-index: 1;

            @media screen and ('min-width: 576px') {
                padding-top: 85px;
            }

            @media screen and ('min-width: 992px') {
                padding-top: 95px;
            }

            @media screen and ('min-width: 1400px') {
                padding-top: 110px;
            }

            @media screen and ('min-width: 1600px') {
                padding-top: 125px;
            }

            @media screen and ('min-width: 1800px') {
                padding-top: 145px;
            }

            .jumbotron {
                background-color: transparent;
                height: 220px;

                h1, .lead {
                    font-family: var(--sv-h1-font-family);
                    font-size: 40px;
                    font-weight: bold;
                    line-height: 1;
                    margin-bottom: 25px;
                    text-align: left;

                    @media screen and ('min-width: 768px') {
                        text-align: center;
                    }
                }
            }

            .img-fluid {
                margin-left: auto;
                margin-right: auto;
                height: 150px;
            }
        }

        .dropdown-menu {
            background-color: #0e1929;
            border: 1px solid white;

            @media screen and ('min-width: 768px') {
                box-shadow: 0px 0px 15px -5px black;
            }

            a {
                text-align: center;

                &:hover {
                    background: #3e4a5f;
                }
            }
        }

        .container {
            position: relative;
            z-index: 1;
            padding-bottom: 100px;

            @media screen and ('min-width: 1400px') {
                max-width: 1340px;
            }

            @media screen and ('min-width: 1600px') {
                max-width: 1540px;
            }

            @media screen and ('min-width: 1800px') {
                max-width: 1740px;
            }

            .spinner-border {
                margin-left: 12px;
                width: 1.3rem;
                height: 1.3rem;
            }

            #surveyContainer {
                text-align: left;

                .sv_container {
                    margin-bottom: 100px;
                }
            }

            .container-questions {
                box-shadow: 0 4px 25px 0 rgba(0,0,0,0.1);
                margin-bottom: 18px !important;
                overflow: hidden;

                .added {
                    padding: 8px 10px;
                    transition: all 0.5s;

                    input[type="text"], select, textarea {
                        background-color: #f3f3f3;
                    }

                    hr {
                        display: none;
                    }

                    .align-vertical-col {
                        align-self: center;
                    }

                    .custom-checkbox {
                        .custom-control-label {
                            text-align: left;

                            span {
                                width: 100%;
                            }
                        }

                        @media screen and ('min-width: 992px') {
                            width: 160px;
                        }

                        @media screen and ('min-width: 1200px') {
                            width: 180px;
                        }

                        @media screen and ('min-width: 1400px') {
                            width: 200px;
                        }

                        @media screen and ('min-width: 1600px') {
                            width: 240px;
                        }

                        @media screen and ('min-width: 1800px') {
                            width: 280px;
                        }
                    }

                    .custom-select {
                        float: left;
                    }

                    .container-text-question {
                        padding-left: 20px;
                        position: relative;

                        &:before {
                            color: #1F73B7;
                            content: '·';
                            font-size: 32px;
                            font-weight: bold;
                            left: 5px;
                            line-height: 0;
                            position: absolute;
                            top: 11px;
                        }
                    }

                    .container-text-subquestion {
                        padding-left: 42px;
                        position: relative;

                        &:before {
                            color: #1F73B7;
                            content: '-';
                            font-size: 22px;
                            font-weight: bold;
                            left: 27px;
                            line-height: 0;
                            position: absolute;
                            top: 10px;
                        }
                    }

                    .container-label-textarea {
                        padding-left: 42px;
                        position: relative;

                        &:before {
                            color: #1F73B7;
                            content: '-';
                            font-size: 22px;
                            font-weight: bold;
                            left: 27px;
                            line-height: 0;
                            position: absolute;
                            top: 47%;
                        }
                    }

                    &:hover {
                        background-color: rgba(0,0,0,.075);
                    }
                }
            }

            .title-bold {
                font-weight: bold;
                color: #696969;
            }

            .container-next-step {
                border-radius: 8px;
                box-shadow: 0 4px 25px 0 rgba(0,0,0,0.1);
                overflow: hidden;
            }

            .container-input-user {
                border-radius: 8px 8px 0 0;
                box-shadow: 0 4px 25px 0 rgba(0,0,0,0.1);

                .step2-p {
                    text-align: left;
                }

                .step3-p {
                    text-align: left;

                    p {
                        word-wrap: break-word;
                    }
                }

                .jumbotron {
                    padding-top: 20px;

                    h1 {
                        font-size: 45px;
                        font-weight: bold;
                        line-height: 1;
                        margin-bottom: 25px;

                        @media screen and ('min-width: 768px') {
                            font-size: 65px;
                        }
                    }

                    .contact-form {
                        .taxpayer-card {
                            margin-bottom: 24px;

                            .input-group {
                                margin-bottom: 10px;

                                @media screen and ('min-width: 768px') {
                                    &:nth-child(2), &:nth-child(3),
                                    &:nth-child(9), &:nth-child(10) {
                                        display: inline-flex;
                                        width: calc(50% - 5px);
                                    }

                                    &:nth-child(3),
                                    &:nth-child(10) {
                                        margin-left: 10px;
                                    }
                                }

                                .invalid-feedback {
                                    text-align: left;
                                }
                            }
                        }

                        .spouse-card {
                            .input-group {
                                margin-bottom: 10px;

                                .invalid-feedback {
                                    text-align: left;
                                }
                            }
                        }
                    }
                }
            }

            .add-comments {
                p {
                    padding: 0 30px;
                }
            }

            .wait-text {
                margin: 0;
                transform: rotateX(0deg);
                animation: ani-loading-txt 12s linear infinite;

                & + span {
                    display: none;
                }
            }

            @keyframes ani-loading-txt {
                50% {
                    transform: rotateX(0deg);
                }

                100% {
                    transform: rotateX(360deg);
                }
            }
        }

        .container-fluid.footer {
            background-color: var(--secondary-color);

            .copy-right-text {
                color: #fff;
                font-size: 14px;
                margin-bottom: 0px;
                padding: 30px;
            }

            div img {
                padding: 24px 0 24px 0;

                @media screen and ('max-width: 440px') {
                    width: 60px;
                }

                @media screen and ('min-width: 576px') {
                    width: 60px;
                }

                @media screen and ('min-width: 992px') {
                    width: 80px;
                }

                @media screen and ('min-width: 1400px') {
                    width: 100px;
                }

                @media screen and ('min-width: 1600px') {
                    width: 120px;
                }

                @media screen and ('min-width: 1800px') {
                    width: 140px;
                }
            }
        }
    }
</style>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator';
import {User} from '../components/common/user/User';
import {Util} from '../util/Util';
import { firebase } from '../util/firebase';
import axios from 'axios';
import StripePay from './StripePay.vue'
import PubSub from 'pubsub-js';
import * as SurveyVue from 'survey-vue'
import 'survey-vue/survey.css'
import { openDB, deleteDB } from 'idb';

const Survey = (SurveyVue as any).Survey

@Component<Home>({
  components: {
      StripePay,
      Survey,
  },
  metaInfo() {
    return {
      title: this.metaTitle || 'Tax Return Preparation Quote',
      meta: [{ name: 'description', content: this.metaDescription || '' }],
    }
  },
})
export default class Home extends Vue {

    protected user: User = new User();

    protected step: number = 0;

    protected nextStepLoading: boolean = false;

    protected years: string = '';

    protected price: string = '$0';

    protected contactId: string = '';

    protected engagementId: string = '';

    protected engagementStatus: string = '';

    protected fullName: string = '';

    protected spouseFullName: string = '';

    protected envelopeId: string = '';

    protected isEmailExists: boolean = false;

    protected comment: string = '';

    protected contactForm: any = {
        email: '',
        user_password: '',
        user_repeat_password: '',
        firstname: '',
        middlename: '',
        lastname: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        country: '',
        zip: '',
        phone1: '',
        phone2: '',
        spouse: {
          firstname: '',
          middlename: '',
          lastname: '',
        },
    };

    protected urlContact: any = {};

    protected system_config: any = {
      quickquote_title: 'Quick Quote',
      firm_name: '',
      docusign_enabled: true,
      taxreturn_agreement: '',
    };

    protected ui_settings: any = {
      primary_logo_url: '',
      secondary_logo_url: '',
      tertiary_logo_url: '',
      background_logo_url: '',
    };

    /*
        All of the form controls support a state prop, which can be used to set the form control into one of three contextual states:
            false (denotes invalid state) is great for when there's a blocking or required field. A user must fill in this field properly to submit the form.
            true (denotes valid state) is ideal for situations when you have per-field validation throughout a form and want to encourage a user through the rest of the fields.
            null Displays no validation state (neither valid nor invalid)
    */
    protected emailState: any = null;

    protected emailWarningText: string = '';

    protected emailRe: RegExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    protected passwordState: any = null;

    protected passwordWarningText: string = '';

    protected repeatPasswordState: any = null;

    protected repeatPasswordWarningText: string = '';

    protected firstNameState: any = null;

    protected firstNameWarningText: string = '';

    protected lastNameState: any = null;

    protected lastNameWarningText: string = '';

    protected quickQuoteFiles: any = null;

    protected survey: any = null;

    protected surveyId: any = null;

    protected surveyName: any = null;

    protected isAcceptAgreement: boolean = false;

    protected metaTitle: any = null;

    protected metaDescription: any = null;

    protected isSignInWith: any = false;

    protected storageName: any = 'qqSurveyPrevData';

    protected indexedDBObject: any = null;

    /**
     * =====================================================================
     * LIFECYCLE HOOKS & INITIALIZATION
     * =====================================================================
     */

    /**
     * Vue lifecycle hook - called when the component is created
     *
     * This is the main initialization function for the multi-step survey intake form.
     * It handles several key scenarios:
     *
     * WORKFLOW STEPS:
     * - Step 0: Initial survey questionnaire (tax questions)
     * - Step 1: Contact information form (with Google/Facebook OAuth)
     * - Step 2: Confirmation page
     * - Step 3: Agreement/DocuSign page
     * - Step 4: Stripe payment page
     * - Step 5: Redirect to detailed questionnaire
     * - Step 6: Already active, redirect to login
     * - Step 7: Error state
     *
     * INITIALIZATION SCENARIOS:
     * 1. New user starting survey - Load question definitions
     * 2. Returning from DocuSign (dsreturn param) - Resume at payment step
     * 3. Resuming via email link (resume param) - Restore engagement state
     *
     * RESPONSIBILITIES:
     * - Load system configuration (titles, firm name, colors, logos)
     * - Initialize SurveyJS questionnaire
     * - Handle OAuth redirects from DocuSign
     * - Restore user session from email resume links
     * - Track analytics events
     */
    protected async created() {
        this.nextStepLoading = false;
        firebase.firestore().collection('system_config').doc('quickquote.title').get().then((doc) => {
          this.system_config.quickquote_title = doc.data().value;
        })
        firebase.firestore().collection('system_config').doc('firm.name').get().then((doc) => {
          this.system_config.firm_name = doc.data().value;
        })
        PubSub.subscribe('uploadedFile', (event, data) => {
            this.quickQuoteFiles = data.fileList;
        })
        axios({
          method: 'post',
          url: '/getUISettings',
        }).then((resp) => {
          for (const item of resp.data) {
            if (item.id == 'color.primary') {
              document.documentElement.style.setProperty('--primary-color', item.value)
            } else if (item.id == 'color.secondary') {
              document.documentElement.style.setProperty('--secondary-color', item.value)
            } else if (item.id == 'color.tertiary') {
              document.documentElement.style.setProperty('--tertiary-color', item.value)
            } else if (item.id == 'color.alternative') {
              document.documentElement.style.setProperty('--alternative-color', item.value)
            } else if (item.id == 'logo.primary') {
              this.ui_settings.primary_logo_url = item.value;
            } else if (item.id == 'logo.secondary') {
              this.ui_settings.secondary_logo_url = item.value;
            } else if (item.id == 'logo.tertiary') {
              this.ui_settings.tertiary_logo_url = item.value;
            } else if (item.id == 'logo.background') {
              this.ui_settings.background_logo_url = item.value;
            } 
            // else if (item.id == 'font.family') {
            //   document.documentElement.style.setProperty('--sv-main-font-family', item.value)
            // }
          }
        })
        
        await this.loadQuestionDefinition();
        // 完成签名返回tpa，通过url中的参数判断是否签名成功，签名成功就跳到step4，调用StripePay组件
        if (this.getQueryValue('dsreturn') && this.getQueryValue('event') == 'signing_complete') {
            if (this.getQueryValue('need_spouse_sign')) {
                this.step = 3;
                this.envelopeId = Util.of(sessionStorage.getItem('envelopeId'), '');
                this.contactId = Util.of(sessionStorage.getItem('contactId'), '');
                this.engagementId = Util.of(sessionStorage.getItem('engagementId'), '');
                const contactDocRef = firebase.firestore().collection('contacts').doc(this.contactId);
                contactDocRef.get().then((contactDoc) => {
                    const contactDocData = contactDoc.data();
                    const contactSpouse = contactDocData.spouse;
                    this.contactForm = contactDocData;
                    this.fullName = this.getFullName(contactDocData.firstname, contactDocData.middlename, contactDocData.lastname);
                    if (contactSpouse) {
                      this.spouseFullName = this.getFullName(contactSpouse.firstname, contactSpouse.middlename, contactSpouse.lastname);
                    }
                    sessionStorage.setItem('fullName', this.fullName);
                    contactDocRef.collection('engagements').doc(this.engagementId).get().then((engagementDoc) => {
                        this.years = engagementDoc.data().years;
                        this.price = engagementDoc.data().total_price;
                        this.comment = engagementDoc.data().comment;
                        if (!this.comment) {
                            contactDocRef.collection('engagements').doc(this.engagementId).collection('questionaries').where('owner_uid', '==', this.contactId).get().then((querySnapshot) => {
                                this.comment = querySnapshot.docs[0].data().clientComment;
                            })
                        }
                        this.nextStepLoading = false;
                    })
                })
            } else {
                this.step = 4;
                this.fullName = Util.of(sessionStorage.getItem('fullName'), '');
                const contactId = Util.of(sessionStorage.getItem('contactId'), '');
                const engagementId = Util.of(sessionStorage.getItem('engagementId'), '');
                firebase.firestore().collection('contacts').doc(contactId).collection('engagements').doc(engagementId).get().then((doc) => {
                    this.price = '$' + parseInt(doc.data().total_price.substring(1))
                })
                firebase.firestore().collection('contacts').doc(contactId).collection('engagements').doc(engagementId).set({
                    status: 'DocuSigned',
                }, {merge: true});
            }
        } else if (this.getQueryValue('resume')) {
            // 客户通过邮件链接返回tpa，通过url中的参数获取price和comment显示在step3中
            const self: any = this;
            this.step = 3;
            this.nextStepLoading = true;
            self.contactForm.email = decodeURIComponent(Util.of(this.getQueryValue('em'), ''));
            self.contactId = Util.of(this.getQueryValue('conId'), '');
            self.engagementId = Util.of(this.getQueryValue('engaId'), '');
            sessionStorage.setItem('email', self.contactForm.email);
            sessionStorage.setItem('contactId', self.contactId);
            sessionStorage.setItem('engagementId', self.engagementId);
            axios({
                method: 'post',
                url: '/getUserByEmail',
                data: {
                    email: self.contactForm.email,
                },
            }).then((response) => {
                const uid = response.data.user.uid;
                axios({
                    method: 'post',
                    url: '/generateCustomToken',
                    data: {
                        uid,
                    },
                }).then((response) => {
                    firebase.auth().signInWithCustomToken(response.data.token).then((response) => {
                        firebase.firestore().collection('system_config').doc('docusign.enabled').get().then((doc) => {
                          this.system_config.docusign_enabled = doc.data().value;
                        })
                        firebase.firestore().collection('system_config').doc('taxreturn.agreement').get().then((doc) => {
                          this.system_config.taxreturn_agreement = doc.data().value;
                        })
                        const contactDocRef = firebase.firestore().collection('contacts').doc(this.contactId);
                        contactDocRef.get().then((contactDoc) => {
                            const contactDocData = contactDoc.data();
                            const contactSpouse = contactDocData.spouse;
                            this.fullName = this.getFullName(contactDocData.firstname, contactDocData.middlename, contactDocData.lastname);
                            if (contactSpouse) {
                              this.spouseFullName = this.getFullName(contactSpouse.firstname, contactSpouse.middlename, contactSpouse.lastname);
                            }
                            sessionStorage.setItem('fullName', this.fullName);
                            contactDocRef.collection('engagements').doc(this.engagementId).get().then(async (engagementDoc) => {
                                this.engagementStatus = engagementDoc.data().status;
                                // 如果已完成签名，就去往付款页面
                                if (this.engagementStatus == 'DocuSigned') {
                                    this.step = 4;
                                    firebase.firestore().collection('contacts').doc(this.contactId).collection('engagements').doc(this.engagementId).get().then((doc) => {
                                        this.price = '$' + parseInt(doc.data().total_price.substring(1))
                                    })
                                    this.nextStepLoading = false;
                                    return;
                                }
                                // 如果已完成付款，就登录pacioli2
                                if (this.engagementStatus == 'DepositPaid') {
                                    this.step = 5;
                                    this.nextStepLoading = false;
                                    return;
                                }
                                // 如果已激活，就登录pacioli2
                                if (this.engagementStatus == 'Active') {
                                    this.step = 6;
                                    this.nextStepLoading = false;
                                    return;
                                }
                                // 如果engagement状态为Reviewed（正常），就正常执行签名付款流程
                                if (this.engagementStatus == 'Reviewed') {
                                    this.years = engagementDoc.data().years;
                                    this.price = engagementDoc.data().total_price;
                                    this.comment = engagementDoc.data().comment;
                                    this.surveyId = engagementDoc.data().survey_id;
                                    const surveyDoc = await firebase.firestore().collection('questionaries').doc(this.surveyId).get()
                                    const surveyName = surveyDoc.data().name;
                                    (this as any).$analytics.logEvent('add_to_cart', {
                                      items: [
                                        {
                                          id: this.contactId,
                                          name: surveyName,
                                          list_name: 'not set',
                                          brand: 'global-accountant',
                                          category: 'not set',
                                          variant: 'not set',
                                          list_position: 1,
                                          quantity: this.years,
                                          price: this.price,
                                          checkout_option: 'alternative',
                                        },
                                      ],
                                    });
                                    contactDocRef.collection('engagements').doc(this.engagementId).get().then((querySnapshot) => {
                                        this.envelopeId = querySnapshot.data().envelopeId || ''
                                    });
                                    if (!this.comment) {
                                        contactDocRef.collection('engagements').doc(this.engagementId).collection('questionaries').where('owner_uid', '==', this.contactId).get().then((querySnapshot) => {
                                            this.comment = querySnapshot.docs[0] ? querySnapshot.docs[0].data().clientComment : '';
                                        })
                                    }
                                } else {
                                    // 如果状态不正常就联系管理员
                                    this.step = 7;
                                }
                                this.nextStepLoading = false;
                            })
                        })
                    })
                }).catch((error) => {
                    this.nextStepLoading = false;
                })
            }).catch((error) => {
                this.nextStepLoading = false;
            })
        }
        (this as any).$analytics.logEvent('quote_request_shown');
    }

    /**
     * Extracts a query parameter value from the current URL
     *
     * This function is used to handle various workflow scenarios:
     * - 'dsreturn': User returning from DocuSign signing ceremony
     * - 'event': DocuSign event type (e.g., 'signing_complete')
     * - 'need_spouse_sign': Indicates spouse signature is required
     * - 'resume': User returning via email link
     * - 'em': Email address (URL encoded)
     * - 'conId': Contact ID
     * - 'engaId': Engagement ID
     *
     * @param queryName - The name of the query parameter to extract
     * @returns The value of the query parameter, or null if not found
     *
     * @example
     * // URL: http://example.com?resume=true&em=user@example.com
     * this.getQueryValue('resume') // returns 'true'
     * this.getQueryValue('em') // returns 'user@example.com'
     */
    private getQueryValue(queryName: any) {
        const query = decodeURI(window.location.search.substring(1));
        const vars = query.split('&');
        for (let i = 0; i < vars.length; i++) {
            const pair = vars[i].split('=');
            if (pair[0] == queryName) {
                return pair[1];
            }
        }
        return null;
    }

    /**
     * =====================================================================
     * FILE HANDLING FUNCTIONS
     * =====================================================================
     */

    /**
     * Fetches the actual Blob from a blob URL
     *
     * SurveyJS stores file uploads as temporary blob URLs created by URL.createObjectURL().
     * These URLs point to file data in browser memory and need to be converted back to
     * actual Blob objects before uploading to Firebase Storage.
     *
     * @param blobUrl - The blob URL (e.g., "blob:http://localhost:9060/80c62fe8-...")
     * @returns Promise<Blob> - The actual blob data that can be uploaded
     *
     * @example
     * const blob = await this.fetchBlobFromUrl('blob:http://localhost:9060/abc-123')
     * // blob is now ready to upload to Firebase Storage
     */
    private async fetchBlobFromUrl(blobUrl: string): Promise<Blob> {
      console.log('[fetchBlobFromUrl] Fetching blob from URL:', blobUrl);
      const response = await fetch(blobUrl);
      const blob = await response.blob();
      console.log('[fetchBlobFromUrl] Blob fetched, size:', blob.size, 'type:', blob.type);
      return blob;
    }

    /**
     * Uploads files from survey data to Firebase Storage
     * Extracts file metadata from the answer JSON and uploads each file
     *
     * @param contactId - The contact/user ID
     * @param engagementId - The engagement ID
     * @param answerJSONStr - JSON string containing survey answers with file data
     */
    private async uploadFiles(contactId: string, engagementId: string, answerJSONStr: string) {
        console.log('[uploadFiles] Starting file upload process');
        const answer = JSON.parse(answerJSONStr || '{}');
        const fileList: any[] = [];

        // Extract all file entries from the answer object
        this.extractAndRemoveFilesFromResultJson(answer, fileList);
        console.log('[uploadFiles] Extracted file list count:', fileList.length);

        await this.doUploadFiles(contactId, engagementId, fileList);
        console.log('[uploadFiles] File upload process completed');
    }

    /**
     * Recursively uploads files to Firebase Storage
     * Handles both individual file objects and nested arrays
     *
     * @param contactId - The contact/user ID
     * @param engagementId - The engagement ID
     * @param fileList - Array of file objects or nested arrays containing file objects
     */
    private async doUploadFiles(contactId: string, engagementId: string, fileList: any[]) {
        if (fileList.length === 0) {
          console.log('[doUploadFiles] No files to upload');
          return;
        }

        console.log('[doUploadFiles] Processing', fileList.length, 'file entries');

        for (const fileEntry of fileList) {
          // Handle individual file objects with name and content
          if (fileEntry.name && fileEntry.content) {
            try {
              const storagePath = `engagements/${contactId}/${engagementId}/files/${fileEntry.name}`;
              console.log('[doUploadFiles] Uploading file:', fileEntry.name, 'to path:', storagePath);

              // Fetch the actual blob from the blob URL
              const blob = await this.fetchBlobFromUrl(fileEntry.content);

              // Upload to Firebase Storage
              await firebase.storage().ref().child(storagePath).put(blob);
              console.log('[doUploadFiles] Successfully uploaded:', fileEntry.name);
            } catch (error) {
              console.error('[doUploadFiles] Error uploading file:', fileEntry.name, error);
            }
          }
          // Handle nested arrays (recursive case)
          else if (Array.isArray(fileEntry)) {
            console.log('[doUploadFiles] Processing nested array with', fileEntry.length, 'items');
            await this.doUploadFiles(contactId, engagementId, fileEntry);
          }
          // Handle nested objects (from the FILE array structure)
          else if (typeof fileEntry === 'object') {
            // Extract FILE array if it exists
            for (const key in fileEntry) {
              if (Array.isArray(fileEntry[key])) {
                console.log('[doUploadFiles] Processing nested object key:', key);
                await this.doUploadFiles(contactId, engagementId, fileEntry[key]);
              }
            }
          }
        }
    }

    /**
     * =====================================================================
     * SURVEY FUNCTIONS
     * =====================================================================
     */

    /**
     * Loads and initializes the SurveyJS questionnaire
     *
     * This function is the core of the survey system. It:
     * 1. Loads the questionnaire definition from Firestore (questionaries collection)
     * 2. Loads tax form pricing data for price calculation
     * 3. Initializes the SurveyJS model
     * 4. Sets up file upload handling (converts files to blob URLs)
     * 5. Restores previously saved progress from localStorage
     * 6. Configures auto-save on page navigation
     * 7. Sets up completion handler that calculates price and saves to IndexedDB
     *
     * SURVEY TYPES:
     * - Default: 'QQ-TAXPREP' (general tax preparation)
     * - Custom: 'QQ-{type}' based on route parameter (e.g., QQ-CITIZEN)
     *
     * PRICE CALCULATION:
     * - Survey questions are tagged with taxForm identifiers
     * - Selected answers map to tax forms
     * - Tax form prices are summed to calculate total quote
     *
     * FILE HANDLING:
     * - Files are uploaded via SurveyJS and converted to blob URLs
     * - Blob URLs are stored temporarily in browser memory
     * - On submission, files are uploaded to Firebase Storage
     *
     * @returns Promise that resolves when questionnaire is loaded
     */
    private async loadQuestionDefinition(): Promise<any> {
        console.log('[loadQuestionDefinition] Starting function execution');

        this.surveyName = 'QQ-TAXPREP';
        console.log('[loadQuestionDefinition] Default surveyName set:', this.surveyName);

        if (this.$route.name == 'searchedHome') {
            this.surveyName = 'QQ-' + this.$route.params.qqtype.toUpperCase();
            this.metaTitle = 'Quote - ' + this.$route.params.qqtype.toUpperCase();
            console.log('[loadQuestionDefinition] Route is searchedHome, surveyName updated to:', this.surveyName);
            console.log('[loadQuestionDefinition] metaTitle set to:', this.metaTitle);
        }

        console.log('[loadQuestionDefinition] Fetching questionaries collection with name:', this.surveyName);
        let collection = await firebase.firestore().collection('questionaries')
          .where('name', '==', this.surveyName)
          .get();
        console.log('[loadQuestionDefinition] Questionaries collection fetched, docs count:', collection.docs.length);

        if (!collection.docs[0]) {
            console.log('[loadQuestionDefinition] No document found, falling back to QQ-TAXPREP');
            collection = await firebase.firestore().collection('questionaries')
              .where('name', '==', 'QQ-TAXPREP')
              .get();
            console.log('[loadQuestionDefinition] Fallback collection fetched, docs count:', collection.docs.length);
        }

        console.log('[loadQuestionDefinition] Fetching questionary document with ID:', collection.docs[0].id);
        const doc = await firebase.firestore()
            .collection('questionaries')
            .doc(collection.docs[0].id)
            .get()

        this.surveyId = collection.docs[0].id
        console.log('[loadQuestionDefinition] surveyId set to:', this.surveyId);

        const data = doc.data().content;
        console.log('[loadQuestionDefinition] Document content fetched, data length:', data?.length);

        console.log('[loadQuestionDefinition] Fetching tax_forms collection');
        const coll = await firebase.firestore().collection('tax_forms').get();
        console.log('[loadQuestionDefinition] tax_forms collection fetched, docs count:', coll.docs.length);

        const taxFormPrice: any[] = []
        for (const doc of coll.docs) {
          taxFormPrice.push(doc.data())
        }
        console.log('[loadQuestionDefinition] taxFormPrice array populated with', taxFormPrice.length, 'items');

        console.log('[loadQuestionDefinition] Parsing data as JSON');
        const dataObject = JSON.parse(data)
        console.log('[loadQuestionDefinition] Data parsed successfully');

        this.metaDescription = dataObject.description;
        console.log('[loadQuestionDefinition] metaDescription set to:', this.metaDescription);

        console.log('[loadQuestionDefinition] Creating new SurveyVue.Model');
        this.survey = new SurveyVue.Model(data);
        console.log('[loadQuestionDefinition] Survey model created successfully');

        // Restore Answered Questions for In-Completed Survey
        // https://surveyjs.io/Documentation/Library?id=LibraryOverview#data-restoreanswers
        this.survey.sendResultOnPageNext = true;
        console.log('[loadQuestionDefinition] sendResultOnPageNext set to true');

        this.survey.onPartialSend.add((survey) => {
          console.log('[loadQuestionDefinition] onPartialSend event triggered');
          this.saveSurveyData(survey);
        });

        const prevData = window.localStorage.getItem(this.storageName) || null;
        console.log('[loadQuestionDefinition] Checking for previous data in localStorage:', this.storageName);
        console.log('[loadQuestionDefinition] Previous data found:', !!prevData);

        if (prevData) {
          console.log('[loadQuestionDefinition] Restoring previous survey data');
          const _data = JSON.parse(prevData);
          this.survey.data = _data;
          console.log('[loadQuestionDefinition] Survey data restored');

          if (_data.pageNo) {
            this.survey.currentPageNo = _data.pageNo;
            console.log('[loadQuestionDefinition] Current page restored to:', _data.pageNo);
          }
        }

        this.survey.onUploadFiles.add(async (survey, options) => {
          console.log('[onUploadFiles] File upload triggered');
          console.log('[onUploadFiles] Survey:', survey);
          console.log('[onUploadFiles] Options:', options);

          // Display selected file information
          if (options.files && options.files.length > 0) {
            console.log('[onUploadFiles] Number of files:', options.files.length);

            for (let i = 0; i < options.files.length; i++) {
              const file = options.files[i];
              console.log(`[onUploadFiles] File ${i + 1}:`, {
                name: file.name,
                type: file.type,
                size: file.size,
                lastModified: new Date(file.lastModified).toISOString()
              });
            }

            // Return the files to complete the upload process
            options.callback('success', options.files.map(file => ({
              file: file,
              content: URL.createObjectURL(file)
            })));
          } else {
            console.log('[onUploadFiles] No files provided');
            options.callback('error');
          }
        });

        console.log('[loadQuestionDefinition] Adding onComplete event handler');
        this.survey.onComplete.add(async (sender, options) => {
            console.log('[loadQuestionDefinition.onComplete] Survey completed, processing results');
            const totalArr: any[] = []

            console.log('[loadQuestionDefinition.onComplete] Processing pages, count:', dataObject.pages.length);
            for (const page of dataObject.pages) {
              Object.keys(sender.data).map((qName) => {
                for (const element of page.elements) {
                  if (element.name == qName) {
                    if (element.type == 'checkbox') {
                      for (const choice of element.choices) {
                        if (sender.data[qName].indexOf(choice.value) != -1 && choice.taxForm) {
                          totalArr.push(choice.taxForm)
                          console.log('[loadQuestionDefinition.onComplete] Added taxForm from checkbox:', choice.taxForm);
                        }
                      }
                    } else {
                      if (sender.data[qName] && element.taxForm) {
                        totalArr.push(element.taxForm)
                        console.log('[loadQuestionDefinition.onComplete] Added taxForm from element:', element.taxForm);
                      }
                    }
                  }
                }
              })
            }
            console.log('[loadQuestionDefinition.onComplete] Total taxForms collected:', totalArr.length);

            let totalPrice = 0;
            for (const tax of taxFormPrice) {
              for (const total of totalArr) {
                if (tax.name == total) {
                  totalPrice += parseInt(tax.price)
                  console.log('[loadQuestionDefinition.onComplete] Adding price for', tax.name, ':', tax.price);
                }
              }
            }
            console.log('[loadQuestionDefinition.onComplete] Total price calculated:', totalPrice);

            this.step++;
            console.log('[loadQuestionDefinition.onComplete] Step incremented to:', this.step);

            this.nextStepLoading = false;
            console.log('[loadQuestionDefinition.onComplete] nextStepLoading set to false');

            this.price = '$' + (totalPrice ? totalPrice : 0.01);
            console.log('[loadQuestionDefinition.onComplete] Final price set to:', this.price);

            console.log('[loadQuestionDefinition.onComplete] Deleting surveyAnswerDB');
            await deleteDB('surveyAnswerDB');

            console.log('[loadQuestionDefinition.onComplete] Opening surveyAnswerDB');
            this.indexedDBObject = await openDB('surveyAnswerDB', 1, {
              upgrade(db) {
                console.log('[loadQuestionDefinition.onComplete] Creating surveyAnswerStore object store');
                db.createObjectStore('surveyAnswerStore', {
                  keyPath: 'name'
                });
              }
            });
            console.log('[loadQuestionDefinition.onComplete] IndexedDB opened successfully');

            console.log('[loadQuestionDefinition.onComplete] Adding survey answer to IndexedDB');
            await this.indexedDBObject.add('surveyAnswerStore', { name: 'surveyAnswer', content: JSON.stringify(sender.data) });
            console.log('[loadQuestionDefinition.onComplete] Survey answer saved to IndexedDB');

            console.log('[loadQuestionDefinition.onComplete] Saving survey data to localStorage');
            this.saveSurveyData(sender);
            console.log('[loadQuestionDefinition.onComplete] Survey completion processing finished');
        });

        console.log('[loadQuestionDefinition] Function execution completed');
    }

    /**
     * Saves current survey progress to localStorage for resume capability
     *
     * This function is called automatically when the user navigates between
     * survey pages (onPartialSend event) and when the survey is completed.
     *
     * KEY BEHAVIORS:
     * - Deep clones survey data to avoid mutation issues
     * - Stores current page number for resume functionality
     * - Removes file data (blob URLs) before saving to reduce storage size
     * - Saves to localStorage under key 'qqSurveyPrevData'
     *
     * FILE HANDLING:
     * - Files are removed because blob URLs are temporary and invalid after page reload
     * - Actual files are stored in IndexedDB separately (surveyAnswerDB)
     * - This keeps localStorage size manageable
     *
     * @param survey - The SurveyJS model instance containing current answers
     */
    private saveSurveyData(survey): void {
      const clonedData: any = Util.deepCopy(survey.data, {});
      clonedData.pageNo = survey.currentPageNo;
      this.extractAndRemoveFilesFromResultJson(clonedData, false);

      window.localStorage.setItem(this.storageName, JSON.stringify(clonedData));
    }

    /**
     * Recursively parses SurveyJS result data to extract or remove uploaded files.
     * Files are identified by either base64-encoded content or blob URLs in their data structure.
     *
     * @param result - The SurveyJS result object to parse
     * @param fileList - Optional array to collect file data. If provided, files are extracted to this array.
     *                   If not provided (or false), file entries are removed from the result object.
     */
    private extractAndRemoveFilesFromResultJson(result: any, fileList: any[] | false): void {
      for (const objectKey in result) {
        if (result[objectKey].length) {
          let isFile = false;

          // Iterate through array items to check for file content
          for (const index in result[objectKey]) {
            const item = result[objectKey][index];
      
            // Check if item contains blob URL
            if (item && item.content && item.content.indexOf('blob:http://') != -1) {
              console.log(`[extractAndRemoveFilesFromResultJson] Found file in field: ${objectKey}, index: ${index}`);
              isFile = true;
            } else if (typeof item == 'object') {
              // Recursively process nested objects
              this.extractAndRemoveFilesFromResultJson(item, fileList);
            }
          }

          // Handle file data based on whether fileList is provided
          if (isFile) {
            if (fileList && fileList instanceof Array) {
              // Extract files to the provided array
              console.log(`[extractAndRemoveFilesFromResultJson] Extracting file from field: ${objectKey}`);
              fileList.push(result[objectKey]);
            } else {
              // Remove file data from result object to reduce payload size
              console.log(`[extractAndRemoveFilesFromResultJson] Removing file from field: ${objectKey}`);
              delete result[objectKey];
            }
          } else {
            console.log(`[extractAndRemoveFilesFromResultJson] No files found in field: ${objectKey}`);
          }
        }
      }
    }

    /**
     * =====================================================================
     * NAVIGATION & FLOW CONTROL FUNCTIONS
     * =====================================================================
     */

    /**
     * Navigates back to the previous step in the workflow
     * Used when user clicks "Back to Edit" button
     */
    private prevStep(): void {
        this.step --;
    }

    /**
     * =====================================================================
     * PAYMENT & DOCUSIGN FUNCTIONS
     * =====================================================================
     */

    /**
     * Handles successful payment completion callback from StripePay component
     *
     * WORKFLOW:
     * - Advances to step 5 (redirect to detailed questionnaire)
     * - Logs payment analytics event
     * - Sends Google Analytics purchase event with engagement details
     *
     * @param surveyName - Name of the survey/questionnaire type
     * @param years - Number of tax years being filed
     */
    private async onPaymentCompleted(surveyName, years, paymentOption = 'stripe'): Promise<any> {
        this.step = 5;
        const price = this.price;
        const paymentEventName = paymentOption === 'pay_later' ? 'pay_later' : 'paid_deposit';
        (this as any).$analytics.logEvent(paymentEventName, {
          value: price,
        });
        (this as any).$analytics.logEvent('purchase', {
          items: [
            {
              id: this.contactId,
              name: surveyName,
              list_name: 'not set',
              brand: 'global-accountant',
              category: 'not set',
              variant: 'not set',
              list_position: 1,
              quantity: years,
              price: this.price,
              checkout_option: paymentOption,
            },
          ],
        });
    }

    /**
     * Reloads the page to return to the initial survey step
     * Used on step 2 (confirmation page) "Return to Home" button
     */
    private toHomePage(): void {
      this.nextStepLoading = true;
      window.location.reload();
    }

    /**
     * Advances to the Stripe payment page (Step 4)
     *
     * SCENARIO: When DocuSign is disabled, users accept terms manually
     * and proceed directly to payment
     *
     * ACTIONS:
     * - Fetches pricing from engagement document
     * - Updates engagement status to 'DocuSigned'
     * - Advances to step 4
     */
    private toStripePayPage(): void {
      this.step = 4;
      this.fullName = Util.of(sessionStorage.getItem('fullName'), '');
      const contactId = Util.of(sessionStorage.getItem('contactId'), '');
      const engagementId = Util.of(sessionStorage.getItem('engagementId'), '');
      firebase.firestore().collection('contacts').doc(contactId).collection('engagements').doc(engagementId).get().then((doc) => {
          this.price = '$' + parseInt(doc.data().total_price.substring(1))
      })
      firebase.firestore().collection('contacts').doc(contactId).collection('engagements').doc(engagementId).set({
          status: 'DocuSigned',
      }, {merge: true});
    }

    /**
     * Redirects to the Pacioli2 admin portal detailed questionnaire page
     * Called after successful payment (Step 5)
     */
    private toPacioli2Questions(): void {
        this.nextStepLoading = true;
        window.location.href = process.env.VUE_APP_URL_PREFIX_ADMIN + '/#/questions?engaId=' + sessionStorage.getItem('engagementId') + '&conId=' + sessionStorage.getItem('contactId');
    }

    /**
     * Redirects to the Pacioli2 admin portal login page
     * Called when engagement is already active (Step 6)
     */
    private toPacioli2(): void {
        this.nextStepLoading = true;
        window.location.href = process.env.VUE_APP_URL_PREFIX_ADMIN;
    }

    /**
     * Initiates the DocuSign signing ceremony
     *
     * WORKFLOW:
     * 1. Calls backend to create/retrieve DocuSign envelope
     * 2. Backend returns signing URL
     * 3. Saves envelope ID to engagement document
     * 4. Saves session data for return flow
     * 5. Redirects user to DocuSign signing page
     *
     * RETURN FLOW:
     * - User completes signing
     * - DocuSign redirects back with query params (dsreturn, event)
     * - created() lifecycle hook handles the return
     *
     * @param email - User's email address
     * @param fullname - Full name of primary taxpayer
     * @param spouseFullName - Full name of spouse (if applicable)
     * @param contactId - Firebase contact document ID
     * @param engagementId - Firebase engagement document ID
     * @param envelopeId - Existing DocuSign envelope ID (or empty for new)
     */
    private toDocusign(email: string, fullname: string, spouseFullName: string, contactId: string, engagementId: string, envelopeId: string): void {
        this.nextStepLoading = true;
        axios({
          method: 'post',
          url: '/openSigningCeremonyController',
          data: {
            USER_FULLNAME: fullname,
            SPOUSE_FULLNAME: spouseFullName,
            USER_EMAIL: email,
            YEARS: this.years,
            PRICE: this.price,
            BASE_URL: window.location.origin,
            ENVELOPE_ID: envelopeId,
            CLIENT_USER_ID: contactId,
            SURVEY_ID: this.surveyId,
          },
        }).then((response) => {
            if (response.data.envelopeId) {
                firebase.firestore().collection('contacts').doc(contactId).collection('engagements').doc(engagementId).set({
                    envelopeId: response.data.envelopeId,
                }, {merge: true});
            }
            // 将contactId和engagementId保存在sessionStorage中，方便StripePay调用
            sessionStorage.setItem('contactId', contactId);
            sessionStorage.setItem('engagementId', engagementId);
            sessionStorage.setItem('envelopeId', response.data.envelopeId);
            window.location.href = response.data.url;
        }).catch((error) => {
            console.log('DocusignError', error)
            this.nextStepLoading = false;
        })
    }

    /**
     * =====================================================================
     * ENGAGEMENT CREATION FUNCTIONS
     * =====================================================================
     */

    /**
     * Prepares questionnaire data for storage in Firestore
     * Creates the document structure for contact->engagements->questionaries
     *
     * @param owner_uid - The contact/user ID who owns this questionnaire
     * @param content - The survey answers (with files already removed)
     * @returns Formatted questionnaire document ready for Firestore
     */
    private prepareForEngagementQuestionariesDoc(owner_uid: string, content: any): any {
        const result = {
            name: 'Quick Quote',
            content,
            created_on: new Date().toUTCString(),
            owner_uid,
        };
        return result;
    }

    /**
     * Creates engagement and questionnaire documents in Firestore
     *
     * This is the core function that creates the engagement (tax preparation project)
     * in the system after the user completes the initial survey.
     *
     * WORKFLOW:
     * 1. Retrieves survey answers from IndexedDB
     * 2. Removes file data from answers (files uploaded separately)
     * 3. Creates engagement document with status 'New'
     * 4. Assigns engagement to a reviewer (CPA)
     * 5. Creates assigned-engagement records for both client and reviewer
     * 6. Adds both as members with avatars
     * 7. Uploads survey files to Firebase Storage
     * 8. Saves questionnaire answers
     * 9. Sends email notification to reviewer
     * 10. Advances to next step or redirects to WordPress
     *
     * ENGAGEMENT SOURCE:
     * - 'frontend': Created from tpa_web quick quote (this flow)
     * - 'backend': Created from Pacioli2 admin portal
     *
     * REVIEWER ASSIGNMENT:
     * - Uses default CPA from system config if set
     * - Falls back to username from URL route parameter
     * - Final fallback: 'edparsonscpa'
     *
     * @param owner_uid - The Firebase auth UID of the client
     * @param email - Client's email address
     * @param fullname - Client's full name
     * @param _step - The step number to advance to after creation
     */
    private async createEngagementAndQuestionaries(owner_uid: any, email: string, fullname: string, _step: any): Promise<any> {
        const contactDocRef = firebase.firestore().collection('contacts').doc(owner_uid);
        const engagementCollection = firebase.firestore().collection('contacts').doc(owner_uid).collection('engagements');
        const surveyAnswerData = await this.indexedDBObject.get('surveyAnswerStore', 'surveyAnswer');
        let quickQuoteContentObject = JSON.parse(surveyAnswerData.content || '{}');
        this.extractAndRemoveFilesFromResultJson(quickQuoteContentObject, false);
        const questionariesDoc = this.prepareForEngagementQuestionariesDoc(owner_uid, quickQuoteContentObject);
        let reviewerUsername = this.$route.params.username;
        /**
        engagement添加source字段，两个值，frontend和backend
        frontend意味着这个Engagement是从tpaweb，由用户通过quickquote创建的。
        backend意味着这个Engagement是从pacioli2后台直接创建的。
        这个source是什么值，决定发哪种邮件。
         */
        const engagementDoc = {
            name: fullname + ' ' + Util.getCurrYear(null),
            total_price: this.price,
            status: 'New',
            created_on: new Date().toUTCString(),
            owner_uid,
            source: 'frontend',
            survey_id: this.surveyId,
        };
        engagementCollection.add(engagementDoc).then(async (addedEngagementDocRef) => {
            (this as any).$analytics.logEvent('engagement_started');
            this.contactId = owner_uid;
            this.engagementId = addedEngagementDocRef.id;
            if (!reviewerUsername) {
              reviewerUsername = 'edparsonscpa'
            }
            let querySnapshot: any;
            const defaultCPA = await firebase.firestore().collection('system_config').doc('default.cpa').get();
            if ((defaultCPA as any).data().value) {
              querySnapshot = await firebase.firestore().collection('contacts').where(firebase.firestore.FieldPath.documentId(), '==', (defaultCPA as any).data().value).get();
            } else {
              querySnapshot = await firebase.firestore().collection('contacts').where('username', '==', reviewerUsername).get();
            }
            if (querySnapshot.docs.length == 0) {
              querySnapshot = await firebase.firestore().collection('contacts').where('username', '==', 'edparsonscpa').get();
            }
            const email: any[] = [];
            for (const item of querySnapshot.docs) {
              this.urlContact = item.data()
              this.urlContact.id = item.id
              if (this.urlContact.email && email.indexOf(this.urlContact.email) == -1) {
                  email.push(this.urlContact.email);
              }
            }
            axios({
                method: 'post',
                url: '/sendReviewMailToAdmin',
                data: {
                    email,
                    contactId: this.contactId,
                    engagementId: this.engagementId,
                    engagementName: engagementDoc.name,
                    userFullName: fullname,
                },
            }).then((response) => {
                (this as any).$analytics.logEvent('quote_requested');
            });

            contactDocRef.set({
                    last_engagement: {
                      id: addedEngagementDocRef.id,
                      name: engagementDoc.name,
                      created_on: new Date().toUTCString(),
                    },
                }, {merge: true},
            )
            // assign to reviewer
            firebase.firestore().collection('contacts').doc(this.urlContact.id).collection('assigneed-engagements').add({
              contactId: this.contactId,
              engagementId: this.engagementId,
              engagementName: engagementDoc.name,
              contactName: fullname,
            })
            // assign to creator
            contactDocRef.collection('assigneed-engagements').add({
              contactId: this.contactId,
              engagementId: this.engagementId,
              engagementName: engagementDoc.name,
              contactName: fullname,
            })
            let reviewerAvatarUrl = 'https://image.flaticon.com/icons/svg/761/761824.svg'
            let ownerAvatarUrl = 'https://image.flaticon.com/icons/svg/761/761824.svg'
            // add reviewer and creator to engagement member
            if (this.urlContact.avatar_file_name) {
              const path = 'avatar/' + this.urlContact.id + '/files/' + this.urlContact.avatar_file_name
              reviewerAvatarUrl = await this.getFileUrl(path)
            }
            const contactDoc = await contactDocRef.get();
            if (contactDoc.data().avatar_file_name) {
              const path = 'avatar/' + this.contactId + '/files/' + contactDoc.data().avatar_file_name
              ownerAvatarUrl = await this.getFileUrl(path)
            }
            // add salesSource(reviewer username)
            engagementCollection.doc(addedEngagementDocRef.id).set({
              sales_source: this.urlContact.username,
              members: [{
                uid: this.urlContact.id,
                name: this.urlContact.firstname + ' ' + this.urlContact.lastname,
                role: this.urlContact.role,
                avatar: reviewerAvatarUrl,
              }, {
                uid: this.contactId,
                name: contactDoc.data().firstname + ' ' + contactDoc.data().lastname,
                role: contactDoc.data().role,
                avatar: ownerAvatarUrl,
              }],
            }, {merge: true})
            await this.uploadFiles(this.contactId, this.engagementId, surveyAnswerData.content);
            engagementCollection.doc(addedEngagementDocRef.id).collection('questionaries').doc('quick_quote').set(questionariesDoc).then(addedQuestionariesDocRef => {
                if (process.env.VUE_APP_WORDPRESS_QUOTE_REQUESTED) {
                  window.location.href = process.env.VUE_APP_WORDPRESS_QUOTE_REQUESTED + '?qqtype=' + this.surveyName.toLowerCase()
                } else {
                  this.step = _step;
                  this.nextStepLoading = false;
                }
            }).catch((addQuestionariesDocError) => {
                console.log('addQuestionariesDocError', addQuestionariesDocError);
                this.nextStepLoading = false;
            });
        }).catch(addEngagementDocError => {
            console.log('addEngagementDocError', addEngagementDocError);
            this.nextStepLoading = false;
        });
    }

    /**
     * Gets the download URL for a file in Firebase Storage
     *
     * @param path - The storage path (e.g., 'avatar/userId/files/filename.jpg')
     * @returns Promise<string> - The publicly accessible download URL
     */
    private getFileUrl(path) {
      const storageRef = firebase.storage().ref()
      return storageRef.child(path).getDownloadURL().then((url) => {
        return url
      })
    }

    /**
     * =====================================================================
     * FORM VALIDATION FUNCTIONS
     * =====================================================================
     */

    /**
     * Validates email address on blur event
     * Sets emailState to true/false/null based on validation result
     */
    private onEmailBlur() {
        const self: any = this;
        const email = self.contactForm.email;
        if (email) {
            if (this.emailRe.test(email)) {
                this.emailState = true;
            } else {
                this.emailState = false;
                this.emailWarningText = this.$t('invalidEmailWarning').toString();
            }
        } else {
            this.emailState = false;
            this.emailWarningText = this.$t('emptyEmailWarning').toString();
        }
    }

    /**
     * Validates first name on blur event
     * Sets firstNameState to true/false based on whether field is filled
     */
    private onFirstNameBlur() {
        const self: any = this;
        if (self.contactForm.firstname) {
            this.firstNameState = true;
        } else {
            this.firstNameState = false;
            this.firstNameWarningText = this.$t('emptyFirstnameWarning').toString();
        }
    }

    /**
     * Validates last name on blur event
     * Sets lastNameState to true/false based on whether field is filled
     */
    private onLastNameBlur() {
        const self: any = this;
        if (self.contactForm.lastname) {
            this.lastNameState = true;
        } else {
            this.lastNameState = false;
            this.lastNameWarningText = this.$t('emptyLastnameWarning').toString();
        }
    }

    /**
     * =====================================================================
     * AUTHENTICATION FUNCTIONS
     * =====================================================================
     */

    /**
     * Initiates Google OAuth sign-in flow
     * Calls signInWithPopup with Google provider
     */
    private signInWithGoogle() {
      const provider = new firebase.auth.GoogleAuthProvider();
      this.nextStepLoading = true;
      this.signInWithPopup(provider);
    }

    /**
     * Initiates Facebook OAuth sign-in flow
     * Calls signInWithPopup with Facebook provider
     */
    private signInWithFacebook() {
      const provider = new firebase.auth.FacebookAuthProvider();
      this.nextStepLoading = true;
      this.signInWithPopup(provider);
    }

    /**
     * Generates a random alphanumeric string
     * Used for creating temporary passwords for email/password auth
     *
     * @param length - Number of characters to generate
     * @returns Random string of specified length
     */
    private generateRandomString(length) {
      const result = [] as any;
      const characters: string = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      const charactersLength = characters.length;
      for ( let i = 0; i < length; i++ ) {
        result.push(characters.charAt(Math.floor(Math.random() * charactersLength)));
      }
      return result.join('');
    }

    /**
     * Handles OAuth popup sign-in flow (Google or Facebook)
     *
     * WORKFLOW:
     * 1. Opens OAuth popup window
     * 2. User authenticates with provider
     * 3. Retrieves user data (email, name, uid)
     * 4. Populates contact form
     * 5. Sets validation states to pass
     * 6. Marks as OAuth sign-in (skips password validation)
     *
     * @param provider - Firebase auth provider (Google or Facebook)
     */
    private signInWithPopup(provider) {
      firebase.auth().signInWithPopup(provider).then((result) => {
        // This gives you a Google Access Token. You can use it to access the Google API.
        const token = result.credential.accessToken;
        // The signed-in user info.
        const user = result.user;
        this.contactId = user.uid;
        this.contactForm.email = user.email;
        this.contactForm.firstname = user.displayName.split(' ')[0];
        this.contactForm.lastname = user.displayName.split(' ')[1];
        this.nextStepLoading = false;
        this.isSignInWith = true;
        this.passwordState = true;
        this.repeatPasswordState = true;
        this.onEmailBlur();
        this.onFirstNameBlur();
        this.onLastNameBlur();
      }).catch((error) => {
        console.log('signInWithError', error)
        this.nextStepLoading = false;
      });
    }

    /**
     * Handles form submission from Step 1 (contact information form)
     *
     * This is a complex function that handles multiple authentication scenarios:
     *
     * SCENARIO 1: OAuth Sign-In (Google/Facebook)
     * - User already authenticated via OAuth
     * - Creates/updates contact document in Firestore
     * - Proceeds to engagement creation
     *
     * SCENARIO 2: New Email/Password User
     * - Creates Firebase auth account with random password
     * - Creates contact document
     * - Proceeds to engagement creation
     *
     * SCENARIO 3: Existing Email User
     * - Email already exists in system
     * - Generates custom token for authentication
     * - Signs in existing user
     * - Creates new engagement for existing contact
     *
     * VALIDATION:
     * - Validates email, first name, last name
     * - Displays appropriate error messages
     *
     * WORKFLOW:
     * - Validates form fields
     * - Creates or retrieves user account
     * - Creates contact document if new user
     * - Calls createEngagementAndQuestionaries
     * - Advances to step 2 (confirmation)
     */
    private submitData() {
        (this as any).$analytics.logEvent('quote_next_page');
        this.nextStepLoading = true;
        const clonedForm: any = Object.assign({}, this.contactForm)
        const self: any = this;
        if (!self.emailState) {
            this.emailState = false;
            this.emailWarningText = this.emailWarningText || this.$t('emptyEmailWarning').toString();
            this.nextStepLoading = false;
            return;
        }
        if (!self.firstNameState) {
            this.firstNameState = false;
            this.emailWarningText = this.emailWarningText || this.$t('emptyEmailWarning').toString();
            this.nextStepLoading = false;
            return;
        }
        if (!self.lastNameState) {
            this.lastNameState = false;
            this.emailWarningText = this.emailWarningText || this.$t('emptyEmailWarning').toString();
            this.nextStepLoading = false;
            return;
        }
        delete clonedForm.user_repeat_password;
        if (this.isSignInWith) {
            clonedForm.owner_uid = this.contactId;
            clonedForm.role = 'Client';
            clonedForm.created_on = new Date().toUTCString();
            clonedForm.created_by = this.contactId;
            delete clonedForm.user_password;
            firebase.firestore().collection('contacts').doc(this.contactId).set(clonedForm).then((docRef) => {
                const fullName = this.getFullName(clonedForm.firstname, clonedForm.middlename, clonedForm.lastname);
                sessionStorage.setItem('fullName', fullName);
                this.createEngagementAndQuestionaries(this.contactId, clonedForm.email, fullName, 2);
            }).catch((error) => {
                this.nextStepLoading = false;
            })
        } else {
            clonedForm.user_password = this.generateRandomString(8);
            firebase.auth().createUserWithEmailAndPassword(clonedForm.email, clonedForm.user_password).then((response) => {
                // 如果email不存在则创建user、contact、engagement
                const owner_uid = response.user.uid;
                clonedForm.owner_uid = owner_uid;
                clonedForm.role = 'Client';
                clonedForm.created_on = new Date().toUTCString();
                clonedForm.created_by = owner_uid;
                delete clonedForm.user_password;
                firebase.firestore().collection('contacts').doc(owner_uid).set(clonedForm).then((docRef) => {
                    const fullName = this.getFullName(clonedForm.firstname, clonedForm.middlename, clonedForm.lastname);
                    sessionStorage.setItem('fullName', fullName);
                    this.createEngagementAndQuestionaries(owner_uid, clonedForm.email, fullName, 2);
                }).catch((error) => {
                    this.nextStepLoading = false;
                })
            }).catch((error) => {
                // 如果email已存在则只创建engagement
                console.log('createUserWithEmailAndPasswordError', error)
                if (error.code.indexOf('email-already-in-use') != -1) {
                    this.isEmailExists = true;
                    axios({
                        method: 'post',
                        url: '/getUserByEmail',
                        data: {
                            email: clonedForm.email,
                        },
                    }).then((response) => {
                        const uid = response.data.user.uid;
                        axios({
                            method: 'post',
                            url: '/generateCustomToken',
                            data: {
                                uid,
                            },
                        }).then((response) => {
                            firebase.auth().signInWithCustomToken(response.data.token).then((response) => {
                                firebase.firestore().collection('contacts').doc(uid).get().then((response) => {
                                    const fullName = this.getFullName(response.data().firstname, response.data().middlename, response.data().lastname);
                                    sessionStorage.setItem('fullName', fullName);
                                    this.createEngagementAndQuestionaries(uid, clonedForm.email, fullName, 2);
                                })
                            })
                        }).catch((error) => {
                            this.nextStepLoading = false;
                        })
                    }).catch((error) => {
                        this.nextStepLoading = false;
                    })
                }
            });
        }
    }

    /**
     * =====================================================================
     * UTILITY FUNCTIONS
     * =====================================================================
     */

    /**
     * Constructs a full name from first, middle, and last name components
     *
     * @param firstName - First name
     * @param middleName - Middle name (optional)
     * @param lastName - Last name
     * @returns Full name string with proper spacing, or empty string if all parts are empty
     *
     * @example
     * getFullName('John', 'Q', 'Doe') // returns 'John Q Doe'
     * getFullName('John', '', 'Doe')  // returns 'John Doe'
     */
    private getFullName(firstName: string, middleName: string, lastName: string): any {
        if (firstName || middleName || lastName) {
            return middleName ? (firstName + ' ' + middleName + ' ' + lastName) : (firstName + ' ' + lastName);
        } else {
            return '';
        }
    }

    /**
     * Replaces template placeholders in agreement HTML
     * Used to personalize the tax return agreement text
     *
     * @param html - HTML string with {{years}} and {{price}} placeholders
     * @returns HTML string with placeholders replaced by actual values
     *
     * @example
     * agreementHTMLFilter('<p>Price: {{price}} for {{years}} years</p>')
     * // returns '<p>Price: $500 for 2 years</p>'
     */
    private agreementHTMLFilter(html: string) {
        return html.replace('{{years}}', this.years).replace('{{price}}', this.price)
    }

}
</script>
<style scoped>
    .contact-form .input-group-text {
        width: 150px;
    }
</style>
